export default __webpack_public_path__ + "62414d2a1343763e4b63431b102e0c61.otf";